import script from "./SendFCMModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SendFCMModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__